import React from "react";

import workPassportRoleBasedControlAccountabilityMapDesktop from "../../images/work-passport-role-based-control-accountability-map-desktop.svg";
import workPassportRoleBasedControlAccountabilityMapMobile from "../../images/work-passport-role-based-control-accountability-map-mobile.svg";

import "./WorkPassportRoleBasedControl.css";

export default function WorkPassportRoleBasedControl() {
  return (
    <section
      className="work-passport-role-based-control"
      id="work-passport-role-based-control"
      aria-labelledby="work-passport-role-based-control-title"
    >
      <div className="work-passport-role-based-control__shell">
        <header className="work-passport-role-based-control__header">
          <p className="work-passport-role-based-control__kicker">
            Control without the administration
          </p>
          <h2 id="work-passport-role-based-control-title">
            One system. <em>Clear accountability.</em>
          </h2>
          <p>
            Different views for compliance, operations, training and
            employees—all connected to the same governed readiness record.
          </p>
        </header>

        <picture className="work-passport-role-based-control__map">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportRoleBasedControlAccountabilityMapMobile}
          />
          <img
            src={workPassportRoleBasedControlAccountabilityMapDesktop}
            alt="Role-based Work Passport accountability map"
            loading="lazy"
          />
        </picture>
      </div>
    </section>
  );
}
